import StartChatBanner from "../start-chat-banner";
import FAB from "../fab";
import { useContext } from "preact/hooks";
import { MessagesContext } from "../../contexts";
import {GlobalContext} from "../../contexts/GlobalContext";
import {NavigationContext} from "../../contexts/NavigationContext";

const AppFooter = ({}) => {
  const messages = useContext(MessagesContext);
  const { options } = useContext(GlobalContext);
  const { route, navigate } = useContext(NavigationContext);

  return (
    <div>
      {route.path === "/" && !options.hideContacts && messages.length === 0 && (
        <StartChatBanner />
      )}
      {route.path === "/" && !options.hideContacts && (
        <FAB onClick={() => navigate({ path: "/contacts" })} />
      )}
    </div>
  );
};

export default AppFooter;



// WEBPACK FOOTER //
// ./components/app-footer/index.js